function initializeProductVariations(stayOnPage) {
  const customCursor = document.querySelector('custom-cursor');
  if (customCursor) {
    customCursor.remove();
  }

  // Cache object for product data
  if (!window.productCache) {
    window.productCache = {};
  }

  function updatePriceDisplay(price, compareAtPrice) {
    const priceContainer = document.querySelector('.product-info__price');
    const priceList = document.querySelector('price-list');
    
    if (!priceContainer || !priceList) return;

    // Only consider it on sale if compareAtPrice exists and is greater than price
    const isOnSale = compareAtPrice && compareAtPrice > price;
    
    // Format prices
    const formattedPrice = new Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: 'EUR'
    }).format(price / 100).replace('€', '').trim() + ' €';

    // Update sale price
    const salePriceElement = priceList.querySelector('sale-price');
    if (salePriceElement) {
      salePriceElement.innerHTML = formattedPrice;
      
      // Update compare at price first
      const compareAtPriceElement = priceList.querySelector('compare-at-price');
      if (compareAtPriceElement) {
        if (isOnSale) {
          const formattedComparePrice = new Intl.NumberFormat('de-DE', {
            style: 'currency',
            currency: 'EUR'
          }).format(compareAtPrice / 100).replace('€', '').trim() + ' €';
          
          compareAtPriceElement.innerHTML = formattedComparePrice;
          compareAtPriceElement.removeAttribute('hidden');
        } else {
          compareAtPriceElement.setAttribute('hidden', '');
        }
      }

      // Now update sale price styling based on compare price visibility
      const hasVisibleComparePrice = compareAtPriceElement && !compareAtPriceElement.hasAttribute('hidden');
      
      if (hasVisibleComparePrice) {
        salePriceElement.classList.add('text-on-sale');
        salePriceElement.classList.remove('text-color-primary');
      } else {
        salePriceElement.classList.remove('text-on-sale');
        salePriceElement.classList.add('text-color-primary');
      }
    }

    // Update save amount and badge
    const saveElement = document.querySelector('.save-amount');
    const onSaleBadge = document.querySelector('on-sale-badge');
    
    if (isOnSale) {
      const saveAmount = compareAtPrice - price;
      const formattedSaveAmount = new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: 'EUR'
      }).format(saveAmount / 100).replace('€', '').trim();
      
      if (saveElement) {
        saveElement.textContent = `Save €${formattedSaveAmount}`;
      }
      
      if (onSaleBadge) {
        onSaleBadge.removeAttribute('hidden');
      }
    } else {
      if (saveElement) {
        saveElement.textContent = '';
      }
      
      if (onSaleBadge) {
        onSaleBadge.setAttribute('hidden', '');
      }
    }

    // Dispatch price update event
    document.dispatchEvent(new CustomEvent('price:update', {
      detail: {
        price: price,
        compareAtPrice: compareAtPrice,
        isOnSale: isOnSale,
        formattedPrice: formattedPrice,
        hasVisibleComparePrice: isOnSale
      }
    }));
  }

  function handleSwatchClick(e) {
    const swatch = e.target.closest('.color-swatch[href], .block-swatch[href]');
    if (!swatch || !isPremiumShaktiMat()) return;
    
    e.preventDefault();
    e.stopPropagation();
    
    if (!swatch.hasAttribute('data-handling')) {
      swatch.setAttribute('data-handling', 'true');
      window.handleSwatchChange(swatch);
      setTimeout(() => {
        swatch.removeAttribute('data-handling');
      }, 300);
    }
    return false;
  }

  function isPremiumShaktiMat() {
    return window.location.pathname.includes('/pages/premium-shakti-mat') || 
           window.location.pathname.includes('premium-shakti-mat') ||
           document.querySelector('body[data-template="page.premium-shakti-mat"]') ||
           document.querySelector('[data-section-type="premium-shakti-mat/premium-scripts"]');
  }

  function handleSwatchChange(swatch) {
    const productUrl = swatch.getAttribute('href');
    const productHandle = productUrl.split('/').pop();

    // Update all matching swatches
    const allSwatches = document.querySelectorAll('.color-swatch[href], .block-swatch[href]');
    allSwatches.forEach(s => {
      const sUrl = s.getAttribute('href');
      if (sUrl === productUrl) {
        s.classList.add('is-selected');
      } else {
        s.classList.remove('is-selected');
      }
    });

    // Update color title
    const colorTitleElement = document.querySelector('.variant-picker__option-info .font--bold');
    if (colorTitleElement) {
      const srOnlyElement = swatch.querySelector('.sr-only');
      const colorValue = srOnlyElement ? srOnlyElement.textContent : 
                       (swatch.getAttribute('data-option-value') || swatch.textContent.trim());
      if (colorValue) {
        colorTitleElement.textContent = colorValue;
      }
    }

    // Show loading state
    const galleryContainer = document.querySelector('.product-gallery__media-list');
    if (galleryContainer) {
      galleryContainer.style.opacity = '0.5';
    }

    fetch('/products/' + productHandle + '.js')
      .then(response => response.json())
      .then(product => {
        window.productCache[productHandle] = product;
        
        // Update variant ID in all forms before updating UI
        if (product.variants && product.variants[0]) {
          const variantId = product.variants[0].id;
          document.querySelectorAll('form[action="/cart/add"]').forEach(form => {
            const variantInput = form.querySelector('input[name="id"]');
            if (variantInput) {
              variantInput.value = variantId;
            }
          });
        }

        updateProductUI(product);

        // Trigger custom event for sticky cart
        document.dispatchEvent(new CustomEvent('product:update', {
          detail: {
            product: product,
            variant: product.variants[0],
            handle: productHandle,
            selectedColor: colorTitleElement ? colorTitleElement.textContent : null
          }
        }));
      })
      .catch(error => {
        console.error('Error fetching product data:', error);
        if (galleryContainer) {
          galleryContainer.style.opacity = '1';
        }
      });

    // Update URL without navigation
    const newUrl = new URL(window.location.href);
    newUrl.searchParams.set('variant', productHandle);
    window.history.replaceState({}, '', newUrl.toString());
  }

  function updateProductUI(product) {
    if (!product || !product.variants || !product.variants[0]) return;

    const variant = product.variants[0];
    
    // Update price display
    const priceContainer = document.querySelector('.product-info__price');
    const priceList = document.querySelector('price-list');
    
    if (priceContainer && priceList && variant) {
      const price = variant.price;
      const compareAtPrice = variant.compare_at_price;
      const isOnSale = compareAtPrice && compareAtPrice > price;

      // Format prices
      const formattedPrice = new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: 'EUR'
      }).format(price / 100).replace('€', '').trim() + ' €';

      const salePriceElement = priceList.querySelector('sale-price');
      if (salePriceElement) {
        salePriceElement.innerHTML = formattedPrice;
        salePriceElement.classList.toggle('text-on-sale', isOnSale);
      }

      const compareAtPriceElement = priceList.querySelector('compare-at-price');
      if (compareAtPriceElement) {
        if (isOnSale) {
          const formattedComparePrice = new Intl.NumberFormat('de-DE', {
            style: 'currency',
            currency: 'EUR'
          }).format(compareAtPrice / 100).replace('€', '').trim() + ' €';
          
          compareAtPriceElement.innerHTML = formattedComparePrice;
          compareAtPriceElement.removeAttribute('hidden');

          // Update save amount
          const saveAmount = compareAtPrice - price;
          const formattedSaveAmount = new Intl.NumberFormat('de-DE', {
            style: 'currency',
            currency: 'EUR'
          }).format(saveAmount / 100).replace('€', '').trim();
          
          const saveElement = document.querySelector('.save-amount');
          if (saveElement) {
            saveElement.textContent = `Save €${formattedSaveAmount}`;
          }
        } else {
          compareAtPriceElement.setAttribute('hidden', '');
        }
      }
    }

    // Update gallery
    updateGalleryWithProductImages(product);

    // Initialize carousel
    if (window.galleryUpdateTimeout) {
      clearTimeout(window.galleryUpdateTimeout);
    }

    window.galleryUpdateTimeout = setTimeout(() => {
      initCarousel();
      
      const firstMedia = document.querySelector('.product-gallery__media.is-selected');
      if (firstMedia) {
        firstMedia.style.display = 'block';
        firstMedia.style.opacity = '1';
        firstMedia.style.position = 'relative';
      }

      const galleryContainer = document.querySelector('.product-gallery__media-list');
      if (galleryContainer) {
        galleryContainer.style.opacity = '1';
      }
    }, 100);
  }

  // Make functions globally available
  window.handleSwatchChange = handleSwatchChange;
  window.handleSwatchClick = handleSwatchClick;

  // Remove any existing click listeners
  document.removeEventListener('click', window.handleSwatchClick, true);
  // Add the click listener
  document.addEventListener('click', window.handleSwatchClick, true);

  if (!document.getElementById('video-popup-container')) {
    const videoPopup = document.createElement('div');
    videoPopup.id = 'video-popup-container';
    videoPopup.innerHTML = `
      <div id="video-popup" class="video-popup">
        <div class="video-popup-content">
          <span class="close-video">&times;</span>
          <video id="popup-video" controls>
            <source src="https://cdn.shopify.com/videos/c/o/v/dc48be92657b47d6ac29ee69126db177.mp4" type="video/mp4">
            Your browser does not support the video tag.
          </video>
        </div>
      </div>
    `;
    document.body.appendChild(videoPopup);

    const style = document.createElement('style');
    style.textContent = `
      .video-popup {
        display: none;
        position: fixed;
        z-index: 9999;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        overflow: auto;
        background-color: rgba(0,0,0,0.8);
        align-items: center;
        justify-content: center;
      }
      .video-popup-content {
        position: relative;
        margin: auto;
        width: 90%;
        max-width: 800px;
  }

      #popup-video {
        width: 100%;
        height: auto;
      }
      .video-thumbnail {
        position: absolute;
        top: 10px;
        right: 10px;
        max-width: 127px;
        max-height: 125px;
        cursor: pointer;
        overflow: hidden;
        z-index: 1;
      }
      
      @media (max-width: 991px) {
        .video-thumbnail {
          top: auto;
          bottom: 10px;
          max-width: 83px;
          max-height: 84px;
        }
      }
      
      .video-thumbnail img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      .video-thumbnail::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
      }
    `;
    document.head.appendChild(style);

    const popup = document.getElementById('video-popup');
    const closeBtn = document.querySelector('.close-video');
    const video = document.getElementById('popup-video');

    window.openVideoPopup = function () {
      popup.style.display = 'flex';
      video.play();
    };

    closeBtn.addEventListener('click', function () {
      popup.style.display = 'none';
      video.pause();
    });

    popup.addEventListener('click', function (e) {
      if (e.target === popup) {
        popup.style.display = 'none';
        video.pause();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        popup.style.display = 'none';
        video.pause();
      }
    });
  }

  const swatchLinks = document.querySelectorAll('.color-swatch[href], .block-swatch[href]');

  function updateGalleryWithProductImages(product) {
    const galleryContainer = document.querySelector('.product-gallery__media-list');
    if (!galleryContainer) {
      console.error('Gallery container not found');
      return false;
    }

    // Store original height before updating
    const originalHeight = galleryContainer.offsetHeight;
    galleryContainer.style.minHeight = `${originalHeight}px`;

    if (product && product.media && product.media.length > 0) {
      // Show loading state immediately
      galleryContainer.style.opacity = '0.5';
      
      // Start preparing the new gallery content immediately
      const mediaItems = product.media
        .filter(media => media.media_type === 'image')
        .map((media, index) => {
          const isFirstImage = index === 0;
          return `
            <div class="product-gallery__media snap-center${isFirstImage ? ' is-selected' : ''}" 
                 data-media-type="image" 
                 data-media-id="${media.id}" 
                 style="${isFirstImage ? 'display: block; position: relative; opacity: 1;' : 'display: none;'}"
                 data-loaded="true">
              <img src="${media.src}" 
                   alt="${media.alt || product.title}"
                   class="product-gallery__image"
                   loading="eager"
                   fetchpriority="${isFirstImage ? 'high' : 'auto'}"
                   data-media-id="${media.id}"
                   data-width="${media.width}"
                   data-height="${media.height}"
                   sizes="(max-width: 740px) calc(100vw - 40px), (max-width: 999px) calc(100vw - 64px), min(760px, 42vw)"
                   srcset="${generateSrcSet(media.src)}"
                   style="opacity: 1;">
            </div>
          `;
        }).join('');

      // Update gallery content
      galleryContainer.innerHTML = mediaItems;

      // Add video thumbnail to first image
      const firstImageContainer = galleryContainer.querySelector('.product-gallery__media.is-selected');
      if (firstImageContainer) {
        const videoThumbnail = document.createElement('div');
        videoThumbnail.className = 'video-thumbnail';
        videoThumbnail.innerHTML = `<img src="https://cdn.shopify.com/s/files/1/1575/4475/files/Video-sm-002.png?v=1742682447" alt="Watch Video">`;
        videoThumbnail.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          window.openVideoPopup();
        });
        firstImageContainer.style.position = 'relative';
        firstImageContainer.appendChild(videoThumbnail);
      }

      // Update thumbnails
      const thumbnailList = document.querySelector('.product-gallery__thumbnail-list');
      if (thumbnailList) {
        const thumbnailItems = product.media
          .filter(media => media.media_type === 'image')
          .map((media, index) => {
            const isFirstImage = index === 0;
            return `
              <button type="button" 
                      class="product-gallery__thumbnail${isFirstImage ? ' is-selected' : ''}" 
                      data-media-id="${media.id}" 
                      aria-label="Go to slide ${index + 1}"
                      data-loaded="true">
                <img src="${media.src}" 
                     alt="${media.alt || product.title}"
                     loading="eager"
                     fetchpriority="${isFirstImage ? 'high' : 'auto'}"
                     data-width="${media.width}"
                     data-height="${media.height}"
                     sizes="(max-width: 699px) 56px, 64px"
                     srcset="${generateThumbnailSrcSet(media.src)}"
                     style="opacity: 1;">
              </button>
            `;
          }).join('');

        thumbnailList.innerHTML = thumbnailItems;
      }

      // Wait for the first image to load before showing
      const firstImage = galleryContainer.querySelector('.product-gallery__media.is-selected img');
      if (firstImage) {
        if (firstImage.complete) {
          showGallery();
        } else {
          firstImage.onload = showGallery;
        }
      } else {
        showGallery();
      }

      function showGallery() {
        const firstMedia = galleryContainer.querySelector('.product-gallery__media.is-selected');
        if (firstMedia) {
          firstMedia.style.display = 'block';
          firstMedia.style.opacity = '1';
          firstMedia.style.position = 'relative';
        }

        galleryContainer.style.opacity = '1';
        galleryContainer.style.transition = 'opacity 0.2s ease-in-out';

        // Update height after images are loaded
        const actualHeight = galleryContainer.scrollHeight;
        galleryContainer.style.minHeight = `${actualHeight}px`;

        // Dispatch event to notify sticky cart that images are ready
        document.dispatchEvent(new CustomEvent('gallery:updated', {
          detail: {
            productImage: firstImage ? firstImage.src : null
          }
        }));
      }

      return true;
    }
    
    return false;
  }

  function loadInitialImages() {
    const selectedSwatch = document.querySelector('.color-swatch.is-selected[href], .block-swatch.is-selected[href]');

    let productHandle;
    if (selectedSwatch) {
      const productUrl = selectedSwatch.getAttribute('href');
      productHandle = productUrl.split('/').pop();
    } else {
      const currentProductUrl = window.location.pathname;
      productHandle = currentProductUrl.split('/').pop();

      const matchingSwatch = Array.from(swatchLinks).find(swatch => {
        const swatchUrl = swatch.getAttribute('href');
        const swatchHandle = swatchUrl.split('/').pop();
        return productHandle.includes(swatchHandle) || swatchHandle.includes(productHandle);
      });

      if (matchingSwatch) {
        matchingSwatch.classList.add('is-selected');
        productHandle = matchingSwatch.getAttribute('href').split('/').pop();
      } else if (swatchLinks.length > 0) {
        swatchLinks[0].classList.add('is-selected');
        const productUrl = swatchLinks[0].getAttribute('href');
        productHandle = productUrl.split('/').pop();
      }
    }

    // Add retry mechanism for image loading
    const loadImages = (retryCount = 0) => {
      fetch('/products/' + productHandle + '.js')
        .then(response => response.json())
        .then(product => {
          const success = updateGalleryWithProductImages(product);
          if (!success && retryCount < 3) {
            // If gallery update failed, retry after a delay
            setTimeout(() => loadImages(retryCount + 1), 500);
          } else {
            initCarousel();
          }
        })
        .catch(error => {
          console.error('Error fetching initial product data:', error);
          if (retryCount < 3) {
            // If fetch failed, retry after a delay
            setTimeout(() => loadImages(retryCount + 1), 500);
          }
        });
    };

    loadImages();
  }

  function initCarousel() {
    const mediaCarousel = document.querySelector('media-carousel');
    if (mediaCarousel) {
      const style = document.createElement('style');
      style.textContent = `
        .product-gallery__media {
          opacity: 0;
          transition: opacity 0.3s ease-in-out;
          position: absolute;
          width: 100%;
          height: 100%;
          left: 0;
          top: 0;
        }
        .product-gallery__media.is-selected {
          opacity: 1;
          position: relative;
        }
        .product-gallery__media-list {
          position: relative;
          min-height: 200px; /* Prevent collapse during load */
        }
        .product-gallery__thumbnail-list {
          scroll-behavior: smooth;
        }
        .product-gallery__media[data-loaded="true"] img {
          opacity: 1 !important;
        }
      `;
      document.head.appendChild(style);

      // Ensure proper initialization timing
      const initializeCarousel = (retryCount = 0) => {
        const mediaItems = document.querySelectorAll('.product-gallery__media');
        const thumbnailButtons = document.querySelectorAll('.product-gallery__thumbnail');
        
        if (mediaItems.length === 0 || thumbnailButtons.length === 0) {
          if (retryCount < 5) {
            setTimeout(() => initializeCarousel(retryCount + 1), 200);
          }
          return;
        }

        // Initialize native carousel if available
        if (typeof mediaCarousel.initialize === 'function') {
          try {
            mediaCarousel.initialize();
          } catch(err) {
            console.warn('Non-critical error initializing mediaCarousel:', err);
          }
        }

        // Ensure first item is visible
        const firstMedia = mediaItems[0];
        if (firstMedia) {
          firstMedia.style.display = 'block';
          firstMedia.style.opacity = '1';
          firstMedia.style.position = 'relative';
          firstMedia.classList.add('is-selected');
        }

        // Setup thumbnail click handlers
        thumbnailButtons.forEach((button, index) => {
          button.onclick = function(e) {
            e.preventDefault();
            e.stopPropagation();
            
            mediaItems.forEach(item => {
              item.style.display = 'none';
              item.classList.remove('is-selected');
              item.style.opacity = '0';
            });
            
            thumbnailButtons.forEach(btn => {
              btn.classList.remove('is-selected');
              btn.setAttribute('aria-current', 'false');
            });
            
            if (mediaItems[index]) {
              const selectedMedia = mediaItems[index];
              selectedMedia.style.display = 'block';
              selectedMedia.classList.add('is-selected');
              selectedMedia.style.opacity = '1';
              selectedMedia.style.position = 'relative';
              
              // Ensure image is loaded
              const img = selectedMedia.querySelector('img');
              if (img && !img.complete) {
                img.onload = () => {
                  selectedMedia.setAttribute('data-loaded', 'true');
                  selectedMedia.style.opacity = '1';
                };
              } else {
                selectedMedia.setAttribute('data-loaded', 'true');
                selectedMedia.style.opacity = '1';
              }
            }
            
            button.classList.add('is-selected');
            button.setAttribute('aria-current', 'true');
            
            // Update native carousel if available
            if (mediaCarousel && typeof mediaCarousel.select === 'function') {
              mediaCarousel.setAttribute('initial-index', index.toString());
              try {
                mediaCarousel.select(index, { animate: true });
              } catch(err) {
                console.warn('Non-critical error updating carousel:', err);
              }
            }
            
            return false;
          };
        });

        // Trigger resize to help components adjust
        window.dispatchEvent(new Event('resize'));
      };

      // Start initialization
      initializeCarousel();
    }
  }

  if (swatchLinks[0]) {
    const productUrl = swatchLinks[0].getAttribute('href');
    const productHandle = productUrl.split('/').pop();
    
    fetch('/products/' + productHandle + '.js')
      .then(response => response.json())
      .then(product => {
        if (product && product.media && product.media.length > 0) {
          const firstImage = product.media[0].src;
          if (firstImage) {
            const link = document.createElement('link');
            link.rel = 'preload';
            link.as = 'image';
            link.href = firstImage;
            document.head.appendChild(link);
          }
        }
      })
      .catch(error => {
        console.error('Error preloading first product image:', error);
      });
  }

  function generateSrcSet(src) {
    if (src.includes('/files/')) {
      return src + ' 2000w';
    }

    const widths = [200, 300, 400, 500, 600, 700, 800, 1000, 1200, 1400, 1600, 1800, 2000];
    return widths.map(w => `${src}&width=${w} ${w}w`).join(', ');
  }

  function generateThumbnailSrcSet(src) {
    if (src.includes('/files/')) {
      return src + ' 192w';
    }

    const widths = [56, 64, 112, 128, 168, 192];
    return widths.map(w => `${src}&width=${w} ${w}w`).join(', ');
  }

  const swatchContainer = swatchLinks[0]?.parentElement;
  if (swatchContainer) {
    function updateProductUI(product) {
      // Clear timeout if exists to prevent multiple gallery updates
      if (window.galleryUpdateTimeout) {
        clearTimeout(window.galleryUpdateTimeout);
      }
      
      // Update gallery
      const galleryUpdated = updateGalleryWithProductImages(product);
      
      // Update price
      updateProductPrice(product);
      
      // Initialize carousel after short delay
      window.galleryUpdateTimeout = setTimeout(() => {
        initCarousel();
        
        // Make sure the first image is visible
        const firstMedia = document.querySelector('.product-gallery__media.is-selected');
        if (firstMedia) {
          firstMedia.style.display = 'block';
          firstMedia.style.opacity = '1';
          firstMedia.style.position = 'relative';
        }

        // Reset gallery opacity
        const galleryContainer = document.querySelector('.product-gallery__media-list');
        if (galleryContainer) {
          galleryContainer.style.opacity = '1';
        }
      }, 100);
    }

    function updateProductPrice(product) {
      const priceContainer = document.querySelector('.product-info__price');
      const priceList = document.querySelector('price-list');
      
      if (product.variants && product.variants[0]) {
        const variant = product.variants[0];
        const price = variant.price;
        const compareAtPrice = variant.compare_at_price;
        const isOnSale = compareAtPrice && compareAtPrice > price;

        // Update both price displays
        updatePriceDisplay(price, compareAtPrice);
        
        // Dispatch price change event
        const event = new CustomEvent('price:update', {
          detail: {
            price: price,
            compareAtPrice: compareAtPrice,
            isOnSale: isOnSale
          }
        });
        document.dispatchEvent(event);
      }
    }

    swatchLinks.forEach(swatch => {
      // Prevent default behavior immediately on all swatch links in premium page
      if (window.location.pathname.includes('/pages/premium-shakti-mat') || 
          document.querySelector('body[data-template="page.premium-shakti-mat"]') ||
          document.querySelector('[data-section-type="premium-shakti-mat/premium-scripts"]')) {
        swatch.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          
          // Ensure we're not already handling this swatch
          if (!this.hasAttribute('data-handling')) {
            this.setAttribute('data-handling', 'true');
            
            // Handle the swatch change
            handleSwatchChange(this);
            
            // Clean up after handling
            setTimeout(() => {
              this.removeAttribute('data-handling');
            }, 300);
          }
          
          return false;
        }, true);
        
        // Also prevent the default on mousedown to be extra safe
        swatch.addEventListener('mousedown', function(e) {
          e.preventDefault();
          return false;
        }, true);
      }
    });
  }

  function setupCarouselObserver(mediaCarousel) {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
          if (mediaCarousel.style.maxHeight === '0px') {
            mediaCarousel.style.removeProperty('max-height');
            mediaCarousel.style.setProperty('height', 'auto', 'important');

            const mediaList = mediaCarousel.querySelector('.product-gallery__media-list');
            if (mediaList) {
              const actualHeight = mediaList.scrollHeight;
              mediaCarousel.style.setProperty('min-height', `${actualHeight}px`, 'important');
            }
          }
        }
      });
    });

    observer.observe(mediaCarousel, {
      attributes: true,
      attributeFilter: ['style']
    });

    return observer;
  }

  let carouselObserver = null;
}

document.addEventListener('DOMContentLoaded', function () {
  const isPremiumShaktiMat = 
    window.location.pathname.includes('/pages/premium-shakti-mat') || 
    window.location.pathname.includes('premium-shakti-mat') ||
    document.querySelector('body[data-template="page.premium-shakti-mat"]') ||
    document.querySelector('[data-section-type="premium-shakti-mat/premium-scripts"]');
                             
  if (isPremiumShaktiMat) {
    const container = document.querySelector('.product-info__product-picker');
    if (container) {
      const urlParams = new URLSearchParams(window.location.search);
      const viewParam = urlParams.get('view');
      
      // Always stay on the current page type
      const shouldStayOnPage = true;
      
      setTimeout(() => {
        initializeProductVariations(shouldStayOnPage);
      }, 100);

      // Prevent default navigation on swatch clicks
      document.addEventListener('click', function(e) {
        const swatch = e.target.closest('.color-swatch[href], .block-swatch[href]');
        if (swatch && isPremiumShaktiMat) {
          e.preventDefault();
          e.stopPropagation();
          
          if (!swatch.hasAttribute('data-handling')) {
            swatch.setAttribute('data-handling', 'true');
            window.handleSwatchChange(swatch);
            setTimeout(() => {
              swatch.removeAttribute('data-handling');
            }, 300);
          }
          return false;
        }
      }, true);
    }
  }
});

// Add resize handler to maintain gallery height
window.addEventListener('resize', function() {
  const galleryContainer = document.querySelector('.product-gallery__media-list');
  if (galleryContainer) {
    const actualHeight = galleryContainer.scrollHeight;
    galleryContainer.style.minHeight = `${actualHeight}px`;
  }
});

// Initialize event listeners
document.addEventListener('DOMContentLoaded', function() {
  // Handle add to cart button clicks
  document.querySelectorAll('.button[type="submit"]').forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      
      const form = this.closest('form[action="/cart/add"]');
      if (!form) return;

      const variantId = form.querySelector('input[name="id"]').value;
      if (!variantId) {
        console.error('No variant ID found');
        return;
      }

      // Show loading state
      button.classList.add('is-loading');

      // Add to cart using AJAX
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: [{
            id: variantId,
            quantity: 1
          }]
        })
      })
      .then(response => response.json())
      .then(data => {
        // Remove loading state
        button.classList.remove('is-loading');

        // Trigger cart drawer open
        if (window.theme && typeof window.theme.openCartDrawer === 'function') {
          window.theme.openCartDrawer();
        } else {
          // Fallback: dispatch event that Shopify's theme might listen to
          document.documentElement.dispatchEvent(
            new CustomEvent('cart:open', {
              bubbles: true
            })
          );
          
          // Additional fallback: try to find and click the cart drawer trigger
          const cartTrigger = document.querySelector('[data-action="open-drawer"][aria-controls="cart-drawer"]');
          if (cartTrigger) {
            cartTrigger.click();
          }
        }

        // Update cart count if exists
        fetch('/cart.js')
          .then(response => response.json())
          .then(cart => {
            const cartCount = document.querySelector('.header__cart-count');
            if (cartCount) {
              cartCount.textContent = cart.item_count;
            }
          })
          .catch(error => console.error('Error fetching cart:', error));
      })
      .catch(error => {
        console.error('Error adding to cart:', error);
        button.classList.remove('is-loading');
        
        // Fallback to traditional form submission if AJAX fails
        form.submit();
      });
    });
  });
}); 